'use strict';

const storageKey = 'auForget';
const analyticsEvent = 'Forget';

export default function f($rootScope, analytics, localStorage, userModel) {
  'ngInject';

  /**
   * Emits analytics event which stops ads for this browser.
   */
  function stopRemarketing () {
    if (!parseInt(localStorage.get(storageKey), 10)) {
      analytics.track(analyticsEvent);
      localStorage.set(storageKey, 1);
    }
  }

  return {
    init: function init() {
      $rootScope.$on('userModel:initialized', function () {
        if (userModel.item.auForget) {
          stopRemarketing();
        }
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/stop_remarketing.js